module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Chat App"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Chat App")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-chat clearfix"
  }, [_c('div', {
    staticClass: "people-list",
    attrs: {
      "id": "people-list"
    }
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "search"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/22.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Vincent Porter")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/23.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Aiden Chavez")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle offline"
  }), _vm._v(" left 7 mins ago ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/24.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Mike Thomas")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/women/25.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Erica Hughes")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/women/26.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Ginger Johnston")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/women/27.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Tracy Carpenter")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle offline"
  }), _vm._v(" left 30 mins ago ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/28.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Christian Kelly")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle offline"
  }), _vm._v(" left 10 hours ago ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/women/29.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Monica Ward")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/30.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Dean Henry")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle offline"
  }), _vm._v(" offline since Oct 28 ")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/women/31.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Peyton Mckinney")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chat"
  }, [_c('div', {
    staticClass: "chat-header clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/32.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chat-about"
  }, [_c('div', {
    staticClass: "chat-with"
  }, [_vm._v("Chat with Vincent Porter")]), _vm._v(" "), _c('div', {
    staticClass: "chat-num-messages"
  }, [_vm._v("already 1 902 messages")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-history"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "message-data align-right"
  }, [_c('span', {
    staticClass: "message-data-time"
  }, [_vm._v("10:10 AM, Today")]), _vm._v("     "), _c('span', {
    staticClass: "message-data-name"
  }, [_vm._v("Olia")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "message other-message float-right"
  }, [_vm._v(" Hi Vincent, how are you? How is the project coming along? ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "message-data"
  }, [_c('span', {
    staticClass: "message-data-name"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
    staticClass: "message-data-time"
  }, [_vm._v("10:12 AM, Today")])]), _vm._v(" "), _c('div', {
    staticClass: "message my-message"
  }, [_vm._v(" Are we meeting today? Project has been already finished and I have results to show you. ")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "message-data align-right"
  }, [_c('span', {
    staticClass: "message-data-time"
  }, [_vm._v("10:14 AM, Today")]), _vm._v("     "), _c('span', {
    staticClass: "message-data-name"
  }, [_vm._v("Olia")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "message other-message float-right"
  }, [_vm._v(" Well I am not sure. The rest of the team is not here yet. Maybe in an hour or so? Have you faced any problems at the last phase of the project? ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "message-data"
  }, [_c('span', {
    staticClass: "message-data-name"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
    staticClass: "message-data-time"
  }, [_vm._v("10:20 AM, Today")])]), _vm._v(" "), _c('div', {
    staticClass: "message my-message"
  }, [_vm._v(" Actually everything was fine. I'm very excited to show this to our team. ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "message-data"
  }, [_c('span', {
    staticClass: "message-data-name"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
    staticClass: "message-data-time"
  }, [_vm._v("10:31 AM, Today")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle online",
    staticStyle: {
      "color": "#AED2A6"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle online",
    staticStyle: {
      "color": "#DAE9DA"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "chat-message clearfix"
  }, [_c('textarea', {
    attrs: {
      "name": "message-to-send",
      "id": "message-to-send",
      "placeholder": "Type your message",
      "rows": "3"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v("     "), _c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" "), _c('button', [_vm._v("Send")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e778508!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Chat.vue
// module id = 1339
// module chunks = 2